module.exports = __webpack_public_path__ + "static/media/1POLICY4.23d3ef51.jpg";